import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import SelectUsersMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/users-multi"
import quickAdd_getUsersIds from "../../../../app/quick-add/sections/view/components/forms/functions/get-users-ids"
import EventTypesBlock from "../../../../app/quick-add/sections/view/components/conditions/event-types"
import {EventType} from "../../../gd/const/event"
import getAvailableProjectsByViewType from "../../functions/get-available-projects"
import {EntityType} from "../../../gd/const/item";

type CalendarConditionsType = {
    projects    : ID[]
    users       : ID[]
    eventTypes  : ID[]
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: CalendarConditionsType):void }
}

// const debug = "ViewCalendar_Conditions"
const debug = false

export default function ViewCalendar_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const conditions: CalendarConditionsType = {
            projects    : result.projects,
            users       : result.users,
            eventTypes  : result.eventTypes,
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)

        onUserChange()
    }

    const conditions = props.view.settings

    const initFormData: any = {
        projects    : conditions?.projects || [],
        users       : conditions?.users || [],
        eventTypes  : conditions?.eventTypes || [
            EventType.COMPANY_EVENT,
            EventType.COMPANY_HOLIDAY,
            EventType.PROJECT_DEADLINE,
            EventType.PROJECT_MILESTONE,
            EventType.PROJECT_EVENT,
            EventType.PERSONAL_PAID_VACATION,
            EventType.PERSONAL_TRAVEL,
            EventType.PERSONAL_SICK_LEAVE,
            EventType.MEETING
        ],
    }

    const formStructure = {
        fields          : {
            projects        : { type: 'select',   isRequired: false,  label: 'Projects'},
            users           : { type: 'select',   isRequired: false,  label: 'Users',       onUserChange: onUserChange},
            eventTypes      : { type: 'select',   isRequired: false,  label: 'Event types', onUserChange: onUserChange},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData);

    const projectsIds = form.getValue('projects') || []
    const usersIds = quickAdd_getUsersIds(projectsIds)

    const classes = Classes("ui5-form", props.className)

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form                = {form}
                                    formFieldName       = 'projects'
                                    availableProjects   = {getAvailableProjectsByViewType(props.view.type)}
                                    disabled            = {props.disabled}
                                    parentsFor          = {EntityType.PROJECT}
                                    onParentSelect      = {onParentSelect}/>

                <SelectUsersMulti label                 = "Users"
                                  form                  = {form}
                                  formFieldName         = 'users'
                                  usersIds              = {usersIds}
                                  includeCurrentUser    = {true}
                                  disabled              = {props.disabled}/>

                <EventTypesBlock form           = {form}
                                 formFieldName  = 'eventTypes'
                                 disabled       = {props.disabled}/>
            </div>
        </div>
    )
}
